import { RETURN_STATUSES } from '../constants/consumptionReturnTexts';

/**
 * Estado del drawer para recibir o consultar una devolución existente. Una recibida muestra lo
 * aceptado; una pendiente o anulada, lo autorizado.
 * @param {Object} row Devolución del listado.
 * @returns {Object} Formulario con los renglones listos para editar o mostrar.
 */
export const buildReturnDocumentForm = (row) => ({
  ...row,
  items: row.items.map((item) => ({
    ...item,
    quantity: String(
      row.status === RETURN_STATUSES.RECEIVED ? item.accepted_quantity : item.quantity
    ),
    limit: item.quantity,
    key: item.uuid,
  })),
});
